module.exports = __webpack_public_path__ + "media/images/medkit-d5d8fc00519d44cbef7418ce5b39b3b4.svg";